import { useQuery } from 'react-query';
import { useAuth } from '@iamexperiences/feature-auth';
import { MSGraphScopes, MANAGEAGENTS } from './shared/constants';
import { getMSGraphScopeAndEndPoint } from './shared/util';

/**
 * Hook to check if user has any sponsored agent service principals
 * @returns Query result with boolean indicating if user has sponsored agents
 */
export const useLeftNavHasSponsoredAgents = () => {
  const auth = useAuth();

  interface IServicePrincipal {
      id?: string;
      servicePrincipalType?: string;
      displayName?: string;
  }

  return useQuery({
    queryKey: ['hasSponsoredAgents', auth.auth.user?.objectId],
    queryFn: async () => {
      const { scope, MSGraphEndPoint } = getMSGraphScopeAndEndPoint(MSGraphScopes.AgentIdentityReadAll);
      const token = await auth.auth.acquireToken({ scopes: [scope] });
      const url = `${MSGraphEndPoint}/beta/users/${auth.auth.user?.objectId}/sponsorOf/microsoft.graph.servicePrincipal?$top=999`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch sponsored agents');
      }

      const data = await response.json();
      const servicePrincipals = data?.value || [];
      const agentServicePrincipals = servicePrincipals.filter(
        (sp: IServicePrincipal) => sp.servicePrincipalType === MANAGEAGENTS.AGENT_IDENTITY_SERVICE_PRINCIPAL_TYPE
      );

      return agentServicePrincipals.length > 0;
    },
    enabled: !!auth.auth.user?.objectId,
  });
};
